'use client';
import styled from 'styled-components';

export const StyledCheckoutBar = styled.div`
  background-color: ${props => props.theme.colors.background.base};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.spacing(3, 4)};
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
`;

export const BackColumn = styled.div`
  margin: auto 0 0 0;
`;

export const SkipColumn = styled.div`
  margin: auto;
  min-width: ${props => (props.$withButton ? '164px' : 'none')};
`;

export const ContinueColumn = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: ${props =>
    props.$centerSkip ? 'column' : props.$hasPrice ? 'column' : 'row'};

  @media ${props => props.theme.tablet} {
    flex-direction: ${props => (props.$hasPrice ? 'column' : 'row')};
    gap: ${props => (props.$hasPrice ? 0 : props.theme.spacing(4))};
  }
`;

export const StyledAmountInfo = styled.div`
  ${props => props.theme.typography.heading6};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const PriceBeforeDiscount = styled.p`
  color: ${props => props.theme.colors.text.secondary};
  font-weight: normal;
  text-decoration-line: line-through;
`;

export const Price = styled.p`
  margin-left: ${props => props.theme.spacing(1)};
`;

export const StyledHeadline = styled.div`
  ${props => props.theme.typography.heading6};
`;

export const SaveText = styled.span`
  ${({ theme }) => theme.typography.body}
  color: ${({ theme }) => theme.colors.status.successPrimary};
  margin-left: ${({ theme }) => theme.spacing(1)};
`;
